import { apiClient } from "../apiClient";
import {
  CASE_LAW_ENDPOINTS,
  BACKEND_ENDPOINTS,
} from "../apiEndpoints";

export const searchCasesApi = (requestBody, signal) =>
  apiClient.post(`${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${CASE_LAW_ENDPOINTS.SEARCH}`, requestBody, { signal });

export const searchFacetsApi = (endpoint) =>
  apiClient.get(endpoint, { headers: { "Content-Type": "application/json" } });

export const fetchCaseListingApi = (payload, signal) =>
  apiClient.post(`${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${BACKEND_ENDPOINTS.LEGAL_TERMS_SEARCH}`, payload, { signal });

export const fetchCaseSuggestionsApi = (query) =>
  apiClient.get(`${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${CASE_LAW_ENDPOINTS.FETCH_SUGGESTIONS}`, { q: query});

export const fetchLegalTermsSuggestionsApi = (payload, signal) =>
  apiClient.post(`${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${BACKEND_ENDPOINTS.LEGAL_TERMS_SUGGESTION}`, payload, { signal });
